// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Unified Filters Styles
 * Consistent filter section for all management pages
 */

/* Unified Filters Section */
.unified-filters-section {
    margin-bottom: 30px;
    margin: 0 25px 30px 25px;
}

.unified-search-filters-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
}

.unified-search-section {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.unified-filters-section-right {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.unified-search-section .unified-form-group,
.unified-filters-section-right .unified-form-group {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.unified-search-section .unified-form-label,
.unified-filters-section-right .unified-form-label {
    margin-bottom: 8px;
    font-weight: 600;
    color: #2d3748;
    font-size: 0.9rem;
}

.unified-filters-section-right .unified-quick-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 0;
}

.unified-search-input-container {
    position: relative;
    min-height: 48px;
}

.unified-filters-section-right .unified-quick-filters {
    min-height: 48px;
    align-items: flex-start;
    padding-top: 10px;
}

.unified-search-button {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
    border: none;
    border-radius: 8px;
    padding: 8px 12px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.unified-search-button:hover {
    background: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);
    transform: translateY(-50%) scale(1.05);
    box-shadow: 0 4px 12px rgba(234, 88, 12, 0.4);
}

.unified-search-button:active {
    transform: translateY(-50%) scale(0.95);
}

/* Enhanced Quick Filters Section */
.unified-quick-filters {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 16px;
    padding: 20px;
    background:
        radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
        linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
    border-radius: 16px;
    border: 1px solid rgba(102, 126, 234, 0.1);
    backdrop-filter: blur(10px);
    position: relative;
    overflow: hidden;
}

.unified-quick-filters::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.02) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.02) 0%, transparent 50%);
    pointer-events: none;
}

.unified-quick-filter-btn {
    background: rgba(255, 255, 255, 0.8);
    border: 2px solid rgba(102, 126, 234, 0.2);
    border-radius: 12px;
    padding: 10px 16px;
    font-size: 0.875rem;
    font-weight: 600;
    color: #2d3748;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.unified-quick-filter-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);
    transition: left 0.5s ease;
}

.unified-quick-filter-btn:hover::before {
    left: 100%;
}

.unified-quick-filter-btn:hover {
    background: rgba(255, 255, 255, 1);
    border-color: rgba(234, 88, 12, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(234, 88, 12, 0.2);
}

.unified-quick-filter-btn.active {
    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
    border-color: #EA580C;
    color: white;
    box-shadow: 0 4px 16px rgba(234, 88, 12, 0.3);
}

.unified-quick-filter-btn.active::before {
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
}

/* Additional Filters */
.unified-additional-filters {
    margin-top: 20px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

/* Form Input Styles */
.unified-form-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid rgba(102, 126, 234, 0.3);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    font-size: 14px;
    font-weight: 500;
    color: #2d3748;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.unified-form-input:focus {
    outline: none;
    border-color: rgba(13, 59, 102, 0.5);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.unified-form-input:disabled {
    background: rgba(255, 255, 255, 0.5);
    color: #9ca3af;
    cursor: not-allowed;
    border-color: rgba(102, 126, 234, 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
    .unified-filters-section {
        margin: 0 20px 20px 20px;
    }

    .unified-search-filters-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .unified-search-section,
    .unified-filters-section-right {
        padding: 20px;
    }

    .unified-quick-filters {
        padding: 16px;
    }

    .unified-quick-filter-btn {
        padding: 8px 12px;
        font-size: 12px;
    }

    .unified-search-button {
        padding: 8px 12px;
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .unified-filters-section {
        margin: 0 15px 15px 15px;
    }

    .unified-search-section,
    .unified-filters-section-right {
        padding: 15px;
    }

    .unified-quick-filters {
        padding: 12px;
    }

    .unified-quick-filter-btn {
        padding: 6px 10px;
        font-size: 11px;
    }

    .unified-search-button {
        padding: 6px 10px;
        font-size: 11px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/UnifiedFilters.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,uCAAuC;IACvC,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb;;;4FAGwF;IACxF,mBAAmB;IACnB,0CAA0C;IAC1C,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;wFAEoF;IACpF,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;IACrB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,sFAAsF;AAC1F;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA,sBAAsB;AACtB;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":["/**\n * Unified Filters Styles\n * Consistent filter section for all management pages\n */\n\n/* Unified Filters Section */\n.unified-filters-section {\n    margin-bottom: 30px;\n    margin: 0 25px 30px 25px;\n}\n\n.unified-search-filters-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 30px;\n    align-items: start;\n}\n\n.unified-search-section {\n    display: flex;\n    flex-direction: column;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 20px;\n    padding: 25px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.unified-filters-section-right {\n    display: flex;\n    flex-direction: column;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 20px;\n    padding: 25px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.unified-search-section .unified-form-group,\n.unified-filters-section-right .unified-form-group {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.unified-search-section .unified-form-label,\n.unified-filters-section-right .unified-form-label {\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #2d3748;\n    font-size: 0.9rem;\n}\n\n.unified-filters-section-right .unified-quick-filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 0;\n}\n\n.unified-search-input-container {\n    position: relative;\n    min-height: 48px;\n}\n\n.unified-filters-section-right .unified-quick-filters {\n    min-height: 48px;\n    align-items: flex-start;\n    padding-top: 10px;\n}\n\n.unified-search-button {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n    border: none;\n    border-radius: 8px;\n    padding: 8px 12px;\n    color: white;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.unified-search-button:hover {\n    background: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);\n    transform: translateY(-50%) scale(1.05);\n    box-shadow: 0 4px 12px rgba(234, 88, 12, 0.4);\n}\n\n.unified-search-button:active {\n    transform: translateY(-50%) scale(0.95);\n}\n\n/* Enhanced Quick Filters Section */\n.unified-quick-filters {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-top: 16px;\n    padding: 20px;\n    background:\n        radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n        radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n        linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n    border-radius: 16px;\n    border: 1px solid rgba(102, 126, 234, 0.1);\n    backdrop-filter: blur(10px);\n    position: relative;\n    overflow: hidden;\n}\n\n.unified-quick-filters::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background:\n        radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.02) 0%, transparent 50%),\n        radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.02) 0%, transparent 50%);\n    pointer-events: none;\n}\n\n.unified-quick-filter-btn {\n    background: rgba(255, 255, 255, 0.8);\n    border: 2px solid rgba(102, 126, 234, 0.2);\n    border-radius: 12px;\n    padding: 10px 16px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #2d3748;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.unified-quick-filter-btn::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);\n    transition: left 0.5s ease;\n}\n\n.unified-quick-filter-btn:hover::before {\n    left: 100%;\n}\n\n.unified-quick-filter-btn:hover {\n    background: rgba(255, 255, 255, 1);\n    border-color: rgba(234, 88, 12, 0.4);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(234, 88, 12, 0.2);\n}\n\n.unified-quick-filter-btn.active {\n    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n    border-color: #EA580C;\n    color: white;\n    box-shadow: 0 4px 16px rgba(234, 88, 12, 0.3);\n}\n\n.unified-quick-filter-btn.active::before {\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n}\n\n/* Additional Filters */\n.unified-additional-filters {\n    margin-top: 20px;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 20px;\n    padding: 25px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n/* Form Input Styles */\n.unified-form-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 2px solid rgba(102, 126, 234, 0.3);\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.9);\n    backdrop-filter: blur(10px);\n    font-size: 14px;\n    font-weight: 500;\n    color: #2d3748;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.unified-form-input:focus {\n    outline: none;\n    border-color: rgba(13, 59, 102, 0.5);\n    background: rgba(255, 255, 255, 1);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.unified-form-input:disabled {\n    background: rgba(255, 255, 255, 0.5);\n    color: #9ca3af;\n    cursor: not-allowed;\n    border-color: rgba(102, 126, 234, 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .unified-filters-section {\n        margin: 0 20px 20px 20px;\n    }\n\n    .unified-search-filters-grid {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n\n    .unified-search-section,\n    .unified-filters-section-right {\n        padding: 20px;\n    }\n\n    .unified-quick-filters {\n        padding: 16px;\n    }\n\n    .unified-quick-filter-btn {\n        padding: 8px 12px;\n        font-size: 12px;\n    }\n\n    .unified-search-button {\n        padding: 8px 12px;\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 480px) {\n    .unified-filters-section {\n        margin: 0 15px 15px 15px;\n    }\n\n    .unified-search-section,\n    .unified-filters-section-right {\n        padding: 15px;\n    }\n\n    .unified-quick-filters {\n        padding: 12px;\n    }\n\n    .unified-quick-filter-btn {\n        padding: 6px 10px;\n        font-size: 11px;\n    }\n\n    .unified-search-button {\n        padding: 6px 10px;\n        font-size: 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
